import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppService } from 'src/@core/services/app.service';
import { EmployerUploadService } from 'src/@core/services/employer/employer-upload.service';
import { JobService } from 'src/@core/services/job/job.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { entityTypes, roles } from 'src/app/shared/helpers/roles-permissions';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'hour4u-admin-create-purchase-order',
  templateUrl: './create-purchase-order.component.html',
  styleUrls: ['./create-purchase-order.component.scss']
})
export class CreatePurchaseOrderComponent implements OnInit {
  profile = this.appService.getCurrentAccount();
  poForm: FormGroup;
  servicesFormArray: FormArray;
  variableJobRateCards: FormArray;
  selectedFileNames: string[] = [];
  maxlengthworkTermsAndConditions = 200;
  leftworkTermsAndConditionsCharacters = 200;
  selectedRow: any = null;
  baseImageUrl = environment.image_url;
  action: string = 'Create';
  agencyList: any[] = [];
  quoteIdShow: boolean = false;
  isLoading: boolean = false;
  diameter = 30;
  loaderColor: string;
  mode = 'indeterminate';
  roles = roles;
  entityTypes = entityTypes;
  perList: any[] = [
    {
      name: 'Task',
      value: 'Task'
    },
    // {
    //   name: 'PER DURATION',
    //   value: 'PER DURATION'
    // },
    {
      name: 'Hour',
      value: 'Hour'
    },
    {
      name: 'Day',
      value: 'Day'
    },
    {
      name: 'Week',
      value: 'Week'
    },
    {
      name: 'Month',
      value: 'Month'
    },
  ];

  constructor(
    public dialogRef: MatDialogRef<CreatePurchaseOrderComponent>,
    @Inject(MAT_DIALOG_DATA) public selectedProject: any,
    private appService: AppService,
    private _fb: FormBuilder,
    private employerUploadService: EmployerUploadService,
    private jobService: JobService,
    private notify: NotificationService
  ) { }

  ngOnInit() {
    console.log("$$$$$$$$$$$$", this.selectedProject)
    this.poForm = this._fb.group({
      selectedAgency: ['', [Validators.required]],
      selectedQuote: [''],
      servicesFormArray: this._fb.array([
        this.rateCardForm
      ]),
      variableJobRateCards: this._fb.array([]),
      expiryDate: ['', [Validators.required]],
      paymentTerms: ['', [Validators.required]],
      additionalTermsAndConditions: [],
      attachments: this._fb.array([])
    })
    this.setAgencyList();
    if (this.selectedProject.action == 'Edit') {
      this.action = 'Update';
      this.selectedRow = this.selectedProject;
      this.quoteIdShow = true;
      this.setInitialValuesAtPOUpdateTime();
    } else {
      if (this.selectedProject && this.selectedProject.quoteDetails && this.selectedProject.withQuote) {
        this.quoteIdShow = true;
        this.setInitialValuesAtPOCreateTime();
      } else {
        this.quoteIdShow = false;
        this.setInitialValueWithoutQuote();
      }
    }

    if (this.selectedProject.billingType == 'NONE') {
      this.poForm.controls['paymentTerms'].setValidators([]);
      this.poForm.controls['paymentTerms'].updateValueAndValidity();
      this.servicesFormArray = this.poForm.get('servicesFormArray') as FormArray;
      this.servicesFormArray.clear();
      this.variableJobRateCards = this.poForm.get('variableJobRateCards') as FormArray;
      this.variableJobRateCards.clear();
    }

    if (this.profile.entity.entityType === 'AGENCY') {
      this.poForm.controls.selectedAgency.setValue(this.profile.entity.id);
      console.log("this.poForm.controls.selectedAgency", this.poForm.controls.selectedAgency.value)
    }
  }

  setAgencyList() {
    if (this.selectedProject.assignedEntities && this.selectedProject.assignedEntities.length) {
      this.selectedProject.assignedEntities.forEach(ele => {
        this.agencyList.push(ele);
      })
    }
    // Disable agencies present in the poList
    if (this.selectedProject.poList && this.selectedProject.poList.length) {
      this.selectedProject.poList.forEach(element => {
        if (element.agencyDetails.id) {
          const foundAgency = this.agencyList.find(agency => agency.id === element.agencyDetails.id);
          if (foundAgency) {
            foundAgency.disabled = true;
          }
        }
      });
    }
    console.log(this.agencyList, this.selectedProject.poList)
  }

  selectedAgency(agency: any) {
    console.log("agency=", agency)
    if (this.selectedProject.quotationRequired) {
      const httpParams = new HttpParams()
        .set('jobId', this.selectedProject.id.toString())
      // .set('agencyId', agency.id.toString())
      this.jobService.getQuotations(httpParams).subscribe((res: any) => {
        if (res && res.length) {
          res.forEach(element => {
            if (element.agencyDetails.id == agency.id) {
              this.selectedProject.withQuote = true;
              this.selectedProject.quoteDetails = element;
            }
            const foundAgency = this.agencyList.find(agency => agency.id === element.agencyDetails.id && element.status == 'ACCEPTED');
            if (foundAgency) {
              foundAgency.disabled = true;
            }
          });
        }
      })
    }
  }

  get rateCardForm() {
    return this._fb.group({
      type: ['', [Validators.required]],
      rate: [null],
      quantity: [null, [Validators.required]],
      days: [null, [Validators.required]],
      isEdit: [true],
      budgetFromHour4u: [null],
      yourRate: [null, [Validators.required]],
      proposedAmount: [null, [Validators.required]],
    });
  }

  get variableRateCardForm() {
    return this._fb.group({
      type: ['', [Validators.required]],
      rate: [null],
      quantity: [null, [Validators.required]],
      per: [null, [Validators.required]],
      isEdit: [true],
      budgetFromHour4u: [null],
      yourRate: [null, [Validators.required]],
      proposedAmount: [null, [Validators.required]],
    });
  }

  get servicesFormArrayForm() {
    return this.poForm.get('servicesFormArray') as FormArray;
  }

  get variableJobRateCardsForm() {
    return this.poForm.get('variableJobRateCards') as FormArray;
  }

  // set initial form values at create PO time
  setInitialValuesAtPOCreateTime() {
    if (this.selectedProject && this.selectedProject.quoteDetails && this.selectedProject.quoteDetails.agencyDetails && this.selectedProject.quoteDetails.agencyDetails.id) {
      this.poForm.controls['selectedAgency'].setValue(this.selectedProject.quoteDetails.agencyDetails.id);
    }
    this.poForm.controls['selectedQuote'].setValue(this.selectedProject.quoteDetails.id);
    if (this.selectedProject && this.selectedProject.quoteDetails && this.selectedProject.quoteDetails.quoteConditions) {
      if (this.selectedProject.quoteDetails.quoteConditions.quoteValidity) {
        this.poForm.controls['expiryDate'].setValue(new Date(this.selectedProject.quoteDetails.quoteConditions.quoteValidity));
      }
      if (this.selectedProject.quoteDetails.quoteConditions.paymentTerms) {
        this.poForm.controls['paymentTerms'].setValue(this.selectedProject.quoteDetails.quoteConditions.paymentTerms);
        this.poForm.controls['additionalTermsAndConditions'].setValue(this.selectedProject.quoteDetails.quoteConditions.addtional);
      }
    }

    this.servicesFormArray = this.poForm.get('servicesFormArray') as FormArray;
    this.servicesFormArray.clear();
    console.log(this.selectedProject)
    if (this.selectedProject.quoteDetails.jobRateCards && this.selectedProject.quoteDetails.jobRateCards.length) {
      this.selectedProject.quoteDetails.jobRateCards.forEach(element => {
        this.servicesFormArray.push(this.rateCardForm);
      });
      this.servicesFormArray.controls.forEach((ele, index) => {
        this.selectedProject.quoteDetails.jobRateCards.forEach((el, i) => {
          el.isEdit = true;
          // el.budgetFromHour4u = el.rate * el.quantity;
          el.yourRate = el.rate;
          el.proposedAmount = el.totalAmount;
          if (i == index) {
            this.servicesFormArray.controls[index].patchValue(el);
          }
        })
      })
    }

    this.variableJobRateCards = this.poForm.get('variableJobRateCards') as FormArray;
    this.variableJobRateCards.clear();
    console.log(this.selectedProject)
    if (this.selectedProject.quoteDetails.variableJobRateCards && this.selectedProject.quoteDetails.variableJobRateCards.length) {
      this.selectedProject.quoteDetails.variableJobRateCards.forEach(element => {
        this.variableJobRateCards.push(this.variableRateCardForm);
      });
      this.variableJobRateCards.controls.forEach((ele, index) => {
        this.selectedProject.quoteDetails.variableJobRateCards.forEach((el, i) => {
          el.isEdit = true;
          // el.budgetFromHour4u = el.rate * el.quantity;
          el.yourRate = el.rate;
          el.proposedAmount = el.totalAmount;
          if (i == index) {
            this.variableJobRateCards.controls[index].patchValue(el);
          }
        })
      })
    }
  }

  // set initial form values at Update PO time
  setInitialValuesAtPOUpdateTime() {
    console.log("@@@@@@@@@@@", this.selectedProject, this.selectedProject.poDetails.agencyDetails)
    if (this.selectedProject && this.selectedProject.poDetails && this.selectedProject.poDetails.agencyDetails && this.selectedProject.poDetails.agencyDetails.id) {
      this.poForm.controls['selectedAgency'].setValue(this.selectedProject.poDetails.agencyDetails.id);
    }
    this.poForm.controls['selectedQuote'].setValue(this.selectedProject.poDetails.quotationId);
    if (this.selectedProject && this.selectedProject.poDetails && this.selectedProject.poDetails.purchaseOrderConditions) {
      if (this.selectedProject.poDetails.purchaseOrderConditions.validationDate) {
        this.poForm.controls['expiryDate'].setValue(new Date(this.selectedProject.poDetails.purchaseOrderConditions.validationDate));
      }
      // if (this.selectedProject.poDetails.purchaseOrderConditions.paymentTerms) {
      this.poForm.controls['paymentTerms'].setValue(this.selectedProject.poDetails.purchaseOrderConditions.paymentTerms);
      this.poForm.controls['additionalTermsAndConditions'].setValue(this.selectedProject.poDetails.purchaseOrderConditions.additionalTerms);
      // }
    }

    this.servicesFormArray = this.poForm.get('servicesFormArray') as FormArray;
    this.servicesFormArray.clear();
    console.log(this.selectedProject)
    if (this.selectedProject.poDetails.jobRateCards && this.selectedProject.poDetails.jobRateCards.length) {
      this.selectedProject.poDetails.jobRateCards.forEach(element => {
        this.servicesFormArray.push(this.rateCardForm);
      });
      this.servicesFormArray.controls.forEach((ele, index) => {
        this.selectedProject.poDetails.jobRateCards.forEach((el, i) => {
          el.isEdit = true;
          // el.budgetFromHour4u = el.rate * el.quantity;
          el.yourRate = el.rate;
          el.proposedAmount = el.totalAmount;
          if (i == index) {
            this.servicesFormArray.controls[index].patchValue(el);
          }
        })
      })
    }

    this.variableJobRateCards = this.poForm.get('variableJobRateCards') as FormArray;
    this.variableJobRateCards.clear();
    console.log(this.selectedProject)
    if (this.selectedProject.poDetails.variableJobRateCards && this.selectedProject.poDetails.variableJobRateCards.length) {
      this.selectedProject.poDetails.variableJobRateCards.forEach(element => {
        this.variableJobRateCards.push(this.variableRateCardForm);
      });
      this.variableJobRateCards.controls.forEach((ele, index) => {
        this.selectedProject.poDetails.variableJobRateCards.forEach((el, i) => {
          console.log(el)
          el.isEdit = true;
          // el.budgetFromHour4u = el.rate * el.quantity;
          el.yourRate = el.rate;
          el.proposedAmount = el.totalAmount;
          if (i == index) {
            this.variableJobRateCards.controls[index].patchValue(el);
          }
        })
      })
    }
  }

  // set Initial Value Without Quote
  setInitialValueWithoutQuote() {
    this.servicesFormArray = this.poForm.get('servicesFormArray') as FormArray;
    this.servicesFormArray.clear();
    console.log(this.selectedProject)
    if (this.selectedProject.rateCards && this.selectedProject.rateCards.length) {
      this.selectedProject.rateCards.forEach(element => {
        this.servicesFormArray.push(this.rateCardForm);
      });
      this.servicesFormArray.controls.forEach((ele, index) => {
        this.selectedProject.rateCards.forEach((el, i) => {
          el.isEdit = true;
          el.budgetFromHour4u = el.rate * el.quantity;
          el.yourRate = el.rate;
          el.proposedAmount = el.budgetFromHour4u;
          if (i == index) {
            this.servicesFormArray.controls[index].patchValue(el);
          }
        })
      })
    }

    this.variableJobRateCards = this.poForm.get('variableJobRateCards') as FormArray;
    this.variableJobRateCards.clear();
    console.log(this.selectedProject)
    if (this.selectedProject.variableJobRateCards && this.selectedProject.variableJobRateCards.length) {
      this.selectedProject.variableJobRateCards.forEach(element => {
        this.variableJobRateCards.push(this.variableRateCardForm);
      });
      this.variableJobRateCards.controls.forEach((ele, index) => {
        this.selectedProject.variableJobRateCards.forEach((el, i) => {
          el.isEdit = true;
          el.budgetFromHour4u = el.rate * el.quantity;
          el.yourRate = el.rate;
          el.proposedAmount = el.budgetFromHour4u;
          if (i == index) {
            this.variableJobRateCards.controls[index].patchValue(el);
          }
        })
      })
    }
  }

  // add more work pictures fields
  addMoreRateCards() {
    this.servicesFormArray = this.poForm.get('servicesFormArray') as FormArray;
    this.servicesFormArray.push(this.rateCardForm);
  }

  // add more Variable amount fields
  addMoreVariableRateCards() {
    this.variableJobRateCards = this.poForm.get('variableJobRateCards') as FormArray;
    this.variableJobRateCards.push(this.variableRateCardForm);
  }

  // Delete picture fields
  deleteRateCard(index) {
    this.servicesFormArray = this.poForm.get('servicesFormArray') as FormArray;
    this.servicesFormArray.removeAt(index);
    console.log(this.servicesFormArray.length)
  }

  // Delete picture fields
  deleteVariableRateCard(index) {
    this.variableJobRateCards = this.poForm.get('variableJobRateCards') as FormArray;
    this.variableJobRateCards.removeAt(index);
    console.log(this.variableJobRateCards.length)
  }

  // get Total Billing
  getTotalBilling() {
    this.servicesFormArray = this.poForm.get('servicesFormArray') as FormArray;
    let totalBilling = 0;
    if (this.servicesFormArray.value.length) {
      this.servicesFormArray.value.forEach(element => {
        totalBilling = totalBilling + (element.rate * element.quantity);
      });
    }
    return totalBilling;
  }

  // get Total Proposed Billing
  getTotalProposedBilling() {
    this.servicesFormArray = this.poForm.get('servicesFormArray') as FormArray;
    this.variableJobRateCards = this.poForm.get('variableJobRateCards') as FormArray;
    let totalBilling = 0;
    if (this.selectedProject.billingType && this.selectedProject.billingType.includes('FIXED')) {
      if (this.servicesFormArray.value.length) {
        this.servicesFormArray.value.forEach(element => {
          totalBilling = totalBilling + (element.proposedAmount);
        });
      }
    }
    if (this.selectedProject.billingType && this.selectedProject.billingType.includes('VARIABLE')) {
      if (this.variableJobRateCards.value.length) {
        this.variableJobRateCards.value.forEach(element => {
          totalBilling = totalBilling + (element.proposedAmount);
        });
      }
    }
    return totalBilling;
  }

  // get Total Billing's 18% GST
  applicableGST() {
    this.servicesFormArray = this.poForm.get('servicesFormArray') as FormArray;
    let totalBilling = 0;
    if (this.servicesFormArray.value.length) {
      this.servicesFormArray.value.forEach(element => {
        totalBilling = totalBilling + (element.rate * element.quantity);
      });
    }
    return totalBilling * 0.18;
  }

  // get Total Billing's 18% GST
  applicableGSTForProposedAmount() {
    this.servicesFormArray = this.poForm.get('servicesFormArray') as FormArray;
    this.variableJobRateCards = this.poForm.get('variableJobRateCards') as FormArray;
    let totalBilling = 0;
    if (this.selectedProject.billingType && this.selectedProject.billingType.includes('FIXED')) {
      if (this.servicesFormArray.value.length) {
        this.servicesFormArray.value.forEach(element => {
          totalBilling = totalBilling + (element.proposedAmount);
        });
      }
    }
    if (this.selectedProject.billingType && this.selectedProject.billingType.includes('VARIABLE')) {
      if (this.variableJobRateCards.value.length) {
        this.variableJobRateCards.value.forEach(element => {
          totalBilling = totalBilling + (element.proposedAmount);
        });
      }
    }
    return totalBilling * 0.18;
  }

  // get Total final Billing with 18% GST
  getTotalFinalBilling() {
    this.servicesFormArray = this.poForm.get('servicesFormArray') as FormArray;
    let totalBilling = 0;
    if (this.servicesFormArray.value.length) {
      this.servicesFormArray.value.forEach(element => {
        totalBilling = totalBilling + (element.rate * element.quantity);
      });
    }
    return totalBilling * 1.18;
  }

  // get Total final Billing with 18% GST
  getTotalFinalBillingForProposedAmount() {
    this.servicesFormArray = this.poForm.get('servicesFormArray') as FormArray;
    this.variableJobRateCards = this.poForm.get('variableJobRateCards') as FormArray;
    let totalBilling = 0;
    if (this.selectedProject.billingType && this.selectedProject.billingType.includes('FIXED')) {
      if (this.servicesFormArray.value.length) {
        this.servicesFormArray.value.forEach(element => {
          totalBilling = totalBilling + (element.proposedAmount);
        });
      }
    }

    if (this.selectedProject.billingType && this.selectedProject.billingType.includes('VARIABLE')) {
      if (this.variableJobRateCards.value.length) {
        this.variableJobRateCards.value.forEach(element => {
          totalBilling = totalBilling + (element.proposedAmount);
        });
      }
    }
    return totalBilling * 1.18;
  }


  jobDateChange(event) {

  }

  onFileSelected(event: Event) {
    const inputElement = event.target as HTMLInputElement;

    if (inputElement.files && inputElement.files.length > 0) {
      const attachmentsArray = this.poForm.get('attachments') as FormArray;

      for (let i = 0; i < inputElement.files.length; i++) {
        const file = inputElement.files[i];

        // Upload the file to S3 using the existing function
        this.employerUploadService.uploadProfileImage(file).subscribe(
          (s3File) => {
            console.log('File uploaded successfully:', s3File);

            attachmentsArray.push(this._fb.control(s3File.key));
            this.selectedFileNames.push(file.name);
          },
          (error) => {
            console.error('Error uploading file:', error);
          }
        );
      }
    }
  }

  // added Propose dRate
  addedProposedRate(index) {
    console.log(index)
    this.servicesFormArray = this.poForm.get('servicesFormArray') as FormArray;
    this.servicesFormArray.value.forEach((element, i) => {
      if (index == i) {
        console.log(element)
        this.servicesFormArray.controls[i].get('proposedAmount').setValue(element.quantity * element.yourRate * element.days);
      }
    })
  }

  // added Propose dRate
  addedProposedRateForVariablePay(index) {
    console.log(index)
    this.variableJobRateCards = this.poForm.get('variableJobRateCards') as FormArray;
    this.variableJobRateCards.value.forEach((element, i) => {
      if (index == i) {
        console.log(element)
        this.variableJobRateCards.controls[i].get('proposedAmount').setValue(element.quantity * element.yourRate);
      }
    })
  }

  // send PO
  sendPO(isDraft: boolean = false) {
    this.isLoading = true;
    console.log(this.selectedProject, this.poForm.value)
    let jobRateCards = [];
    let variableJobRateCards = [];

    if (this.selectedProject && this.selectedProject.billingType && this.selectedProject.billingType.includes('FIXED')) {
      if (this.poForm.value.servicesFormArray && this.poForm.value.servicesFormArray.length) {
        this.poForm.value.servicesFormArray.forEach(element => {
          let obj = {
            "type": element.type,
            "quantity": element.quantity,
            "days": element.days,
            "rate": element.yourRate,
            "totalAmount": element.proposedAmount
          }
          jobRateCards.push(obj);
        });
      }
    }

    if (this.selectedProject && this.selectedProject.billingType && this.selectedProject.billingType.includes('VARIABLE')) {
      if (this.poForm.value.variableJobRateCards && this.poForm.value.variableJobRateCards.length) {
        this.poForm.value.variableJobRateCards.forEach(element => {
          let obj = {
            "type": element.type,
            "quantity": element.quantity,
            "per": element.per,
            "rate": element.yourRate,
            "totalAmount": element.proposedAmount
          }
          variableJobRateCards.push(obj);
        });
      }
    }

    if (this.selectedProject && this.selectedProject.billingType && this.selectedProject.billingType == 'VARIABLE') {
      this.servicesFormArray = this.poForm.get('servicesFormArray') as FormArray;
      this.servicesFormArray.clear();
    }

    if (this.selectedProject && this.selectedProject.billingType && this.selectedProject.billingType == 'FIXED') {
      this.variableJobRateCards = this.poForm.get('variableJobRateCards') as FormArray;
      this.variableJobRateCards.clear();
    }

    if (this.selectedProject && this.selectedProject.billingType && this.selectedProject.billingType == 'NONE') {
      this.servicesFormArray = this.poForm.get('servicesFormArray') as FormArray;
      this.servicesFormArray.clear();
      this.variableJobRateCards = this.poForm.get('variableJobRateCards') as FormArray;
      this.variableJobRateCards.clear();
      this.poForm.controls['paymentTerms'].setValidators([]);
      this.poForm.controls['paymentTerms'].updateValueAndValidity();
    }

    if (!this.poForm.valid) {
      this.poForm.markAllAsTouched();
      this.isLoading = false;
      return;
    } else {
      console.log(this.selectedRow)
      if (this.selectedRow && this.selectedRow.id) {
        this.editPO(isDraft, jobRateCards, variableJobRateCards);
      } else {
        this.createPO(isDraft, jobRateCards, variableJobRateCards);
      }
    }
  }

  // add PO
  createPO(isDraft, jobRateCards, variableJobRateCards) {
    console.log("#############", this.poForm.value.expiryDate)
    const dateString = this.poForm.value.expiryDate;
    const dateObj = new Date(dateString);
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();

    const resultArray: number[] = [year, month, day];
    let obj = {}
    if (this.selectedProject.withQuote) {
      obj = {
        "jobId": this.selectedProject.id,
        "agencyId": this.selectedProject.quoteDetails.agencyDetails.id,
        "vendorId": this.selectedProject.vendorId,
        "attachment": this.poForm.value.attachments,
        "enterpriseId": this.selectedProject.quoteDetails.enterpriseDetails.id,
        "gstAmount": this.applicableGSTForProposedAmount(),
        "jobRateCards": jobRateCards,
        "variableJobRateCards": variableJobRateCards,
        "purchaseOrderConditions": {
          "additionalTerms": this.poForm.value.additionalTermsAndConditions,
          "paymentTerms": this.poForm.value.paymentTerms,
          "validationDate": resultArray,
        },
        "quotationId": this.selectedProject.quoteDetails.id,
        "status": isDraft ? "DRAFT" : "ACCEPTED",
        "totalAmount": this.getTotalFinalBillingForProposedAmount(),
        "totalBillingAmount": this.getTotalProposedBilling()
      }
    } else {
      obj = {
        "jobId": this.selectedProject.id,
        "agencyId": this.poForm.value.selectedAgency,
        "vendorId": this.selectedProject.vendorId,
        "attachment": this.poForm.value.attachments,
        "enterpriseId": this.selectedProject.quoteDetails.enterpriseDetails.id,
        "gstAmount": this.applicableGSTForProposedAmount(),
        "jobRateCards": jobRateCards,
        "variableJobRateCards": variableJobRateCards,
        "purchaseOrderConditions": {
          "additionalTerms": this.poForm.value.additionalTermsAndConditions,
          "paymentTerms": this.poForm.value.paymentTerms,
          "validationDate": resultArray,
        },
        // "quotationId": null,
        "status": isDraft ? "DRAFT" : "ACCEPTED",
        "totalAmount": this.getTotalFinalBillingForProposedAmount(),
        "totalBillingAmount": this.getTotalProposedBilling()
      }
    }
    console.log(obj);
    this.jobService.createPO(obj).subscribe(res => {
      console.log(res)
      this.isLoading = false;
      if (res) {
        this.notify.showMessage('Purchase Order created successfully!', 2000);
        this.dialogRef.close(true);
      }
    }, (err => {
      this.isLoading = false;
      console.log(err)
    }))
  }

  // edit po
  editPO(isDraft, jobRateCards, variableJobRateCards) {
    const dateString = this.poForm.value.expiryDate;
    const dateObj = new Date(dateString);
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();

    const resultArray: number[] = [year, month, day];
    let obj = {
      // "id": this.selectedProject.poDetails.id,
      "jobId": this.selectedProject.id,
      "agencyId": this.selectedProject.poDetails.agencyDetails.id,
      "attachment": this.poForm.value.attachments,
      "enterpriseId": this.selectedProject.poDetails.enterpriseDetails.id,
      "gstAmount": this.applicableGSTForProposedAmount(),
      "jobRateCards": jobRateCards,
      "variableJobRateCards": variableJobRateCards,
      "purchaseOrderConditions": {
        "additionalTerms": this.poForm.value.additionalTermsAndConditions,
        "paymentTerms": this.poForm.value.paymentTerms,
        "validationDate": resultArray,
      },
      "quotationId": this.selectedProject.poDetails.quotationId,
      "status": isDraft ? "DRAFT" : "ACCEPTED",
      "totalAmount": this.getTotalFinalBillingForProposedAmount(),
      "totalBillingAmount": this.getTotalProposedBilling()
    }
    console.log(obj);
    this.jobService.updatePO(obj, this.selectedProject.poDetails.id).subscribe(res => {
      console.log(res)
      this.isLoading = false;
      if (res) {
        this.notify.showMessage('Purchase Order updated successfully!', 2000);
        this.dialogRef.close(true);
      }
    }, (err => {
      console.log(err)
      this.isLoading = false;
    }))
  }

  openDocInNewWindow(url) {
    window.open(url, "_blank");
  }
}
